import Page from '@/components/pages/podcast-episode/PodcastEpisodePageController';
import getStaticPaths from '@/components/pages/podcast-episode/PodcastEpisodePageStaticPaths';
import getStaticProps from '@/components/pages/podcast-episode/PodcastEpisodePageStaticProps';

export default Page;
export { getStaticProps, getStaticPaths };
